import { useState } from "react";
import { Dropdown } from "./dropdown";
import styles from "./styles.module.scss";
import {
  AssignedToIcon,
  AssignmentIcon,
  CalenderIcon,
  CalenderIconBlack,
  CreatedByIcon,
  EyeIcon,
  FilesAttachedIcon,
  StatusIcon,
} from "icons";
import { DatePicker, Divider } from "antd";
import { ConditionalRenderer } from "components";
import { CalendarFilled } from "@ant-design/icons";
import { useGetCategoriesList } from "hooks/use-get-categories";
import { getFormattedDate } from "utils/helpers";
import dayjs from "dayjs";
import { useLanguageTranslator } from "hooks/use-language-translator";

export const EmailFilters = ({
  employees,
  getReminders,
  filtersData,
  setFiltersData,
  setInitialStateOfFilters,
  setEmails,
  totalEmails,
  handleApplyFilters,
}) => {
  const { translator } = useLanguageTranslator();
  const emailNotesTrans = translator("emailNotes");
  const { categories } = useGetCategoriesList();

  const attachmentStatusOptions = [
    {
      label: emailNotesTrans.all,
      value: "all",
      key: "all",
    },
    {
      label: emailNotesTrans.filesAttached,
      value: true,
      key: "filesAttached",
    },
    {
      label: emailNotesTrans.noFilesAttached,
      key: "noFilesAttached",
      value: false,
    },
  ];
  const assignmentOptions = [
    {
      label: emailNotesTrans.all,
      value: "all",
    },
    {
      label: emailNotesTrans.unassigned,
      key: "unassigned",
      value: false,
    },
    {
      label: emailNotesTrans.assigned,
      key: "assigned",
      value: true,
    },
  ];
  const visibilityOptions = [
    {
      label: emailNotesTrans.all,
      value: "all",
      key: "all",
    },
    {
      label: emailNotesTrans.hidden,
      key: "hidden",
      value: true,
    },
    {
      label: emailNotesTrans.visible,
      key: "visible",
      value: false,
    },
  ];

  const dropdowns = [
    {
      name: "hidden",
      options: visibilityOptions,
      label: emailNotesTrans.visibility,
      icon: EyeIcon,
    },
    {
      name: "assigned",
      options: assignmentOptions,
      label: emailNotesTrans.status,
      icon: AssignmentIcon,
    },
    {
      name: "hasAttachments",
      options: attachmentStatusOptions,
      label: emailNotesTrans.attachmentStatus,
      icon: FilesAttachedIcon,
    },
  ];

  // const [filtersData, setFiltersData] = useState({
  //   dueDate: null,
  //   createdBy: null,
  //   assignedTo: null,
  //   status: null,
  //   category: null,
  // });

  const handleSelectOption = (name) => (value, option) => {
    setFiltersData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  function handleChangeDate(date, dateString) {
    setFiltersData((prev) => ({
      ...prev,
      dueDate: dateString,
    }));

    // handleUpdateCase(item.key, dateString);
    // refetchFieldHistory();
  }
  function getFormateDate(date) {
    if (date) {
      if (date?.includes(".")) {
        const format = date?.replace(/\./g, "-");
        return dayjs(format, ["DD-MM-YYYY", "DD-MM-YY"], true);
      } else if (date?.includes("-")) {
        return dayjs(filtersData["dueDate"]);
      }
    }
  }

  return (
    <div>
      <div className={styles.filters}>
        {dropdowns.map((item) => (
          <div className={styles.singleFilter}>
            <div className={styles.label}>
              <item.icon height={15} width={15} />
              {item.label}
            </div>
            <div className={styles.dropdownWrapper}>
              <Dropdown
                options={item.options}
                value={filtersData[item.name]}
                handleSelectOption={handleSelectOption(item.name)}
              />
            </div>
          </div>
        ))}
      </div>
      <Divider />
      <div className={styles.buttons}>
        <div className={styles.clearAll} onClick={setInitialStateOfFilters}>
          {emailNotesTrans.resetAll}
        </div>
        <div className={styles.verticalLine}></div>
        <button className={styles.apply} onClick={handleApplyFilters}>
          {emailNotesTrans.applyFilters}
        </button>
      </div>
    </div>
  );
};
